import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class UserScenario extends BasicScenario {
manageDomains: boolean | null;
manageFeatures: boolean | null;
manageUserApps: boolean | null;
notifyUser: boolean | null;
}

